import axios from "axios";
// @group Mixins
export default {
  methods: {
    storeAccessTokens(keycloak) {
      const accessToken = keycloak.token;
      const tokenValidity = new Date(keycloak.tokenParsed?.exp * 1000);
      const refreshToken = keycloak.refreshToken;

      axios.defaults.headers.common["Authorization"] = `Bearer ${accessToken}`;
      axios.defaults.headers.common["refresh-token"] = refreshToken;
      axios.defaults.headers.common[
        "token-valid-until"
      ] = tokenValidity.toJSON();
    }
  }
};
